module.exports = __webpack_public_path__ + "assets/images/slope-single/tablet.svg?v=2f9fa3c0";